export default "__VITE_ASSET__zN7xveb9__"